import React from 'react';
import {Row, Col} from 'react-bootstrap';
import cssClasses from './ConsoleControls.css'
import PlayerButton from '../../UI/PlayerButton/PlayerButton';
// import ProgressBar from "../ProgressBar/ProgressBar";

const consoleControls = (props) => {

    const effectsColumns = props.soundEffects && props.soundEffects.length > 0 ? props.soundEffects.map(effect => {
            return <Col md={3} key={effect.key} className={cssClasses.ConsoleControlsCol}>
                <PlayerButton
                    key={effect.key}
                    name={effect.name}
                    audioFilePath={effect.file}
                    playing={effect.playing}
                    effectRef={effect.effectRef}
                    onPlayEffect={() => props.onPlayEffect(effect.key)}
                />
            </Col>
        })

        : null;
    return (
        <Row className={cssClasses.ConsoleControls} style={props.style}>
            {effectsColumns}
        </Row>
    );

}

export default consoleControls;